// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"eab14834ec242a7fb025","873":"3a8b8fabf26567f05082"}[chunkId] + ".js";
};